import { GlobalFunctions } from 'globales-projekt-angular';
import { UserQuelleFlaeche } from './user-quelle-flaeche.model';
import { UserQuelleSonstige } from './user-quelle-sonstige.model';
import { UserQuelleStall } from './user-quelle-stall.model';
import { UserWindRichtlinienab } from './user-wind-richtlinienab.model';


export class UserBetrieb {
  bezeichnung: string;
  beschreibung: string;

  userQuelleStallList: UserQuelleStall[] = [];
  userQuelleFlaecheList: UserQuelleFlaeche[] = [];
  userQuelleSonstigeList: UserQuelleSonstige[] = [];

  zusatzabstand: number = 0;
  gewichtungsfaktor: number = 0;

  userWindRichtlinienabList: UserWindRichtlinienab[] = [];

  static isValidBetriebImport(data: unknown): data is UserBetrieb {
    if (!data || typeof data !== 'object') {
      return false;
    }

    const betrieb = data as UserBetrieb;

    return (
      (betrieb.bezeichnung === null || typeof betrieb.bezeichnung === 'string') &&
      (betrieb.beschreibung === null || typeof betrieb.beschreibung === 'string') &&
      typeof betrieb.zusatzabstand === 'number' &&
      typeof betrieb.gewichtungsfaktor === 'number' &&
      GlobalFunctions.isObjectList(betrieb.userQuelleStallList) &&
      GlobalFunctions.isObjectList(betrieb.userQuelleFlaecheList) &&
      GlobalFunctions.isObjectList(betrieb.userQuelleSonstigeList) &&
      GlobalFunctions.isObjectList(betrieb.userWindRichtlinienabList)
    );
  }
}
